import { TFunction } from 'i18next'

enum ProductCategory {
  Rise,
  Storyline,
  More,
}
export default ProductCategory

export function getDisplayNameByCategory(t: TFunction): { [key: number]: string } {
  return {
    [ProductCategory.Rise]: t('productNames.rise'),
    [ProductCategory.Storyline]: t('productNames.storyline'),
    [ProductCategory.More]: t('home.productCategoryFilter.more')
  }
}
